import React from "react";

const pairValue = (value) => value || "-";

export default function MlRoutingFlagReasonCell({ pairs }) {
  if (!Array.isArray(pairs) || pairs.length === 0) {
    return "-";
  }
  return (
    <div className="DashboardMlRouting__FlagReasonList">
      {pairs.map((pair, index) => (
        <div className="DashboardMlRouting__FlagReasonPair" key={`ml-flag-reason-${index}`}>
          <div className="DashboardMlRouting__FlagReasonFlag">{pairValue(pair?.flag)}</div>
          <div className="DashboardMlRouting__FlagReasonText">{pairValue(pair?.reason)}</div>
        </div>
      ))}
    </div>
  );
}
